export const NetworkConfiguration = {
  LOGIN: "user/login",
  PROFILE: "user/profile",
  SEND_OTP: "user/sendOtp",
  VERIFY_OTP: "user/verifyOtp",
  EMAIL_SEND_OTP: "user/email/send-otp",
  EMAIL_VERIFY_OTP: "user/email/verify-otp",
  PHONE_SEND_OTP: "user/phone/send-otp",
  PHONE_VERIFY_OTP: "user/phone/verify-otp",
  REGISTRATION: "user/registration",
  AFFILIATE_CHECK_EMAIL: "user/affiliate/check-email",
  AFFILIATE_BECOME: "user/affiliate/become",
  AFFILIATE_NETWORKS: "user/affiliate/networks",
  AFFILIATE_DASHBOARD: "user/affiliate/dashboard",
  AFFILIATE_SELLERS: "user/affiliate/sellers",
  AFFILIATE_EARNINGS: "user/affiliate/earnings",
  AFFILIATE_WITHDRAW: "user/affiliate/withdraw",
  AFFILIATE_PROFILE: "user/affiliate/profile",
  AFFILIATE_SETTINGS: "user/affiliate/settings",
  AFFILIATE_PROGRAM_DISPLAY: "user/affiliate/program-display",
  USER_DETAILS: "user/userDetails",
  EMAIL_VERIFICATION: "user/emailVerification",
  FORGET_PASSWORD: "user/forgotPassword",
  RESET_PASSWORD: "user/resetPassword",
  SUBSCRIPTION_PLANS: "user/subscription?status=active",
  TRANSACTIONS: "user/transaction",
  WALLET: "user/myWallet",
  MEMBERSHIP: "user/membership",
  UPGRADE_MEMBERSHIP: "user/membership/upgrade",
  WALLET_CREATE_BY_ID: "user/walletCreateById",  // create wallet by user id (temporarily)
  WALLET_ADMIN_ADD_AMOUNT: "user/admin/wallet/", // add amount to user wallet by admin
  CATEGORIES: "product/all/category",
  ALL_CATEGORIES: "product/search/category",
  SEARCH_CATEGORIES_BY_KEYWORD: "admin/category/search",
  BLANK_CATEGORY_CONTENT: "admin/categorycontent",
  PRODUCTS: "product",
  HOME_PRODUCTS: "product/home-products",

  PRODUCT_BY_ID: "product/",
  PRODUCT_VARIATION_BY_PARENT_ID: "product/variations/",
  PRODUCT_BY_SKU: "product/sku/",
  SKU_CATEGORY_STATUS: "product/sku/",
  PRODUCT_BY_QUERY: "/product/search/main",
  PRODUCT_INQUIRY: "product/inquiry",
  CHANGE_PASSWORD: "user/changePassword",
  SUBSCRIBE_PRODUCT: "product/subscribe",
  UNSUBSCRIBE_PRODUCT: "product/unSubscribe",
  DELETE_SUBSCRIPTION: "admin/subscription",
  ADD_SUBSCRIPTION: "admin/subscription/create",
  SUBSCRIBED_PRODUCTS: "product/my/subscribed",
  EXCEL_UNSUBSCRIBED_PRODUCTS: "product/excel/unSubscribe",
  EXCEL_SUBSCRIBED_PRODUCTS: "product/excel/subscribe",
  SUBSCRIPTION_BY_ID: "user/subscription",
  EDIT_SUBSCRIPTION: "admin/subscription",
  SUBSCRIBED_PRODUCTS: "product/my/subscribed",
  GET_PRODUCT_VARIANTS: "product/my/variants",
  EXCEL_UNSUBSCRIBED_PRODUCTS: "product/excel/unSubscribe",
  EXCEL_SUBSCRIBED_PRODUCTS: "product/excel/subscribe",
  MULTIPLE_PRODUCTS_UNSUBSCRIBE: "product/unSubscribe/multiple",
  EXPORT_SUBSCRIBE_PRODUCT: "product/listing/exports",
  EXPORT_SUBSCRIBE_PRODUCT_IN_IMAGE: "product/listing/image",
  EXPORT_AMAZON_TEMPLATE: "product/listing/amazon",
  // Alibaba product subscription endpoints
  ALIBABA_SUBSCRIBE_PRODUCT: "product/alibaba/subscribe",
  ALIBABA_UNSUBSCRIBE_PRODUCT: "product/alibaba/unsubscribe",
  // ALIBABA_GET_DRAFTS: "product/alibaba/drafts",
  // ALIBABA_GET_DRAFT: "product/alibaba/draft",
  ALIBABA_CHECK_SUBSCRIPTION: "product/alibaba/check-subscription",
  ALIBABA_REGENERATE_CONTENT: "product/alibaba/regenerate-content",
  ALIBABA_SUBSCRIBE_MULTIPLE: "product/alibaba/subscribe/multiple",
  EDIT_PRODUCTS: "admin/product",
  GET_ORDERS: "admin/orders",
  CREATE_MANUAL_ORDER: "admin/orders/manual",
  ADMIN_EDIT_ORDER: "admin/orders",
  ADMIN_ORDER_EDIT_PRODUCTS_BY_IDS: "admin/orders/edit-products-by-ids",
  ADMIN_BULK_PAYMENT: "admin/orders/bulk-payment",
  ADMIN_ORDERS_EXPORT_DATE_WISE: "admin/orders/export/date-wise",
  ADMIN_ORDERS_EXPORT_ALL: "admin/orders/export/all",
  ADMIN_USERS_SEARCH: "admin/users/search",
  ADMIN_SEARCH_PRODUCT_BY_SKU: "admin/orders/search-product",
  AUTOPAY: "user/wallet/autoPay",
  AUTORENEWEL: "user/wallet/autoRenewed",
  SETTINGS: "user/viewSetting",
  SELLER_DASHBORAD: "user/userDashBoard",
  UPDATE_SETTINGS: "user/updateSetting",
  GET_ALL_ORDERS: "order",
  GET_ORDER_BY_ID: "order",
  GET_POCESSING_ORDERS: "admin/orders/processed",
  UPLOAD_EXCEL_TRACKING: "admin/orders/tracking",
  GET_ORDER_DETAILS: "order",
  GET_ORDER_DETAILS_UPID: "order/upsaleoOrder",
  UPDATE_ORDERS: "order/",
  UPLOAD_ORDERS: "order/create/bulk",
  PAY_ORDER: "order/payment",
  VERIFY_RAZORPAY_ORDER: "order/razorpay/verify",
  RAISE_TICKET: "order/ticket",
  CANCEL_ORDER: "order/cancel",
  BULK_PAY_ORDERS: "order/bulk/payment",
  BULK_CANCEL_ORDERS: "order/bulk/cancel",
  BULK_RAISE_TICKET: "order/bulk/ticket",
  ABNORMAL_ORDER: "order/abnormal/all",
  GET_FAILED_ORDERS: "order/failed",
  GET_AMAZON_PRODUCT: "order/amazon-product",
  GET_FLIPKART_PRODUCT: "order/flipkart-product",
  EXPORT_ALL_ORDERS: "order/export/all",
  GET_ALL_PRODUCTS: "product",
  ADMIN_PRODUCTS: "admin/products",
  ADMIN_INQUIRIES: "admin/inquiries",
  ADMIN_CONTACTS: "admin/contacts",

  SELLER_SUMMARY: "admin/product/seller-summary",
  ADMIN_PRODUCTS_WITH_CATEGORY_PATH: "admin/products/with-category-path",
  UPDATE_CATEGORY_APPROVAL: "admin/product/update-category-approval",

  ADMIN_PRODUCT_DRAFTS: "admin/product-drafts",
  ADMIN_PRODUCT_DRAFTS_GLOBAL_CATEGORY_FACETS: "admin/product-drafts/global-category-facets",
  ADMIN_PRODUCT_DRAFTS_SKU_UPLOAD_BATCHES: "admin/product-drafts/sku-upload-batches",
  ADMIN_PRODUCT_DRAFTS_EXPORT_SKU_UPLOAD_TEMPLATE: "admin/product-drafts/export-sku-upload-template",
  ADMIN_PRODUCT_DRAFTS_BULK_UPDATE_DIMENSIONS: "admin/product-drafts/bulk-update-dimensions",
  ADMIN_PRODUCT_ERRORS: "admin/product-errors",
  ADMIN_PRODUCT_DRAFTS_STATS: "admin/product-drafts/stats",
  CREATE_ORDER: "user/wallet/addmoney",
  VERIFY_ORDER: "user/wallet/payment",
  ADD_CATEGORY: "admin/category/create",
  EXISTING_CATEGORY: "admin/category",
  ALL_CATEGORIES_FOR_SKU_UPLOAD: "admin/category/all-for-sku-upload",
  GLOBAL_CATEGORIES: "admin/global-categories",
  UPDATE_CATEGORY: "admin/category",
  DELETE_PRODUCT: "admin/product",
  UPLOAD_IMAGE: "admin/product",
  ADD_ORDER: "order/create",
  GOOGLE_LOGIN: "user/googleAuth",
  GET_USERS: "admin/users",
  GET_USERS_DAILY_REPORT: "admin/totalUsersToday",
  GET_USER_BY_ID: "admin/user/",
  UPDATE_USER: "admin/user/",
  ADD_PRODUCTS: "product",
  SYNC_ALL_PRODUCTS: "user/shopify/products",
  SYNC_SELECTED_PRODUCTS: "user/shopify/products",
  CONNECT_TO_SHOPIFY: "user/shopify/connection",
  DISCONNECT_SHOPIFY: "user/shopify/disconnect",
  SHOPIFY_STORE_LIST: "user/myStoreList",
  GET_CHAT: "order/ticket",
  UPDATE_CHAT: "order/ticket",
  TRANSACTION: "admin/transactions",
  TRANSACTION_DETAILS: "order/importerrOrder",
  FAILED_ORDERS: "admin/orders/failed",
  UPLOAD_FAILED_ORDERS_WITH_USERID: "admin/orders/failed/upload",
  UPDATE_FAILED_ORDER_REMARK: "admin/orders/failed",
  DELETE_FAILED_ORDER: "admin/orders/failed",
  DELETE_ORDER: "admin/orders",
  UPDATE_PROFILE: "user/update",
  UPLOAD_EXCEL_PRODUCT: "product/upload",
  IMPORT_ALIBABA_RAW: "product/raw/alibaba/import",
  IMPORT_ALIBABA_ADMIN: "admin/product/alibaba/admin/import",
  WALLET_CHART_DATA: "user/wallet/yearlyData/",
  GET_ADMIN_TICKET: "order/tickets/all",
  GET_ORDER_REFUND: "admin/order/",
  AMAZON_CONNECT: "marketplaces/amazon",
  CONTACT: "user/contactUS",
  CONTACTIB: "user/contactusIB",
  CONTACTCS: "user/questionnaireFormIB",
  CATEGORY_CONTENT: "product/categoryContent/",
  GLOBAL_CATEGORY: "admin/global-category",
  MAP_CATEGORY: "admin/category/map-global",

  // notifications
  NOTIFICATIONS: "user/notifications",
  NOTIFICATIONS_UNSEEN_COUNT: "user/notifications/unseen-count",
  NOTIFICATIONS_MARK_ALL_SEEN: "user/notifications/mark-all-seen",

  // address management
  GET_ADDRESSES: "user/addresses",
  GET_ADDRESS_BY_ID: "user/addresses",
  ADD_ADDRESS: "user/addresses",
  UPDATE_ADDRESS: "user/addresses",
  DELETE_ADDRESS: "user/addresses",
  SET_DEFAULT_ADDRESS: "user/addresses",

  //amazon marketplace api endpoints
  GET_SELLER_APP_ID: "amazon/app-data",
  CONNECT_TO_AMAZON: "amazon/connect",
  SAVE_AMAZON_DATA: "amazon/saveData",

  //featured categoies api endpoints
  GET_ALL_FC: "admin/featuredCategory",
  GET_FC_BY_ID: "admin/featuredCategory",

  //cart api endpoints
  ADD_TO_CART: "user/addToCart",
  REMOVE_FROM_CART: 'user/removeToCart',
  REMOVE_ALL_CART: 'user/removeAllToCart',
  GET_CART: 'user/viewCart',
  GET_CART_COUNT: 'user/cartCount',
  PAYMENT_CONFIRM: "user/order/payment",
  PAYMENT_VERIFY: "user/order/razorpayVerify",
  RAZORPAY_STATUS: "user/razorpay/status",

  // CCAvenue
  CCAVENUE_INITIATE: "payment/initiate",
  CCAVENUE_STATUS: "payment/status/",

  // Bank Transfer
  BANK_TRANSFER_SETTINGS: "user/bank-transfer/settings",
  ABANDONED_LEAD: "user/abandoned-lead",
  BANK_TRANSFER_PLACE_ORDER: "user/bank-transfer/place-order",
  ADMIN_BANK_TRANSFER_SETTINGS: "admin/bank-transfer/settings",
  ADMIN_BANK_TRANSFER_CONFIRM: "admin/bank-transfer/confirm",
  ADMIN_ABANDONED_LEADS: "admin/abandoned-leads",
  ADMIN_ABANDONED_REMINDER_SETTINGS: "admin/abandoned-reminder/settings",
  ADMIN_ABANDONED_REMINDER_BANNER_UPLOAD: "admin/abandoned-reminder/banner-upload",
  ADMIN_ABANDONED_REMINDER_SEND_TEST_ALL_OPEN: "admin/abandoned-reminder/send-test-to-all-open",

  CANTON_FAIR_LEAD_SUBMIT: "user/canton-fair-lead",
  ADMIN_CANTON_FAIR_LEADS: "admin/canton-fair-leads",
  ADMIN_SUPPLIER_INQUIRIES: "admin/supplier-inquiries",

  SUPP1688_PRODUCTS_BY_KEYWORD: "product-by-keyword",

  // Admin AI
  ADMIN_AI_GENERATE: "admin/ai/generate",
  ADMIN_AI_STATUS: "admin/ai/status",
  ADMIN_AI_MODELS_FOR_PAGE: "admin/ai/models-for-page",

  // Admin AI Models
  ADMIN_AI_MODELS: "admin/ai-models",

  // Admin AI Prompts
  ADMIN_AI_PROMPTS: "admin/ai-prompts",

  // Admin AI Usage Logs
  ADMIN_AI_USAGE_LOGS: "admin/ai-usage-logs",
  ADMIN_AI_USAGE_STATS: "admin/ai-usage-stats",

  // Supplier Data Info
  SUPPLIER_DATA_INFO: "admin/supplier-data-info",
  SUPPLIER_DATA_INFO_STATS: "admin/supplier-data-info/stats",

  // Recharge Request (seller)
  RECHARGE_REQUEST: "user/recharge-request",
  // Recharge Requests (admin)
  ADMIN_RECHARGE_REQUESTS: "admin/recharge-requests",
  ADMIN_RECHARGE_APPROVE: "admin/recharge-requests",
  ADMIN_RECHARGE_REJECT: "admin/recharge-requests",
  ADMIN_RECHARGE_WALLET_INFO: "admin/recharge-requests",
  ADMIN_RECHARGE_DEDUCT: "admin/recharge-requests",
  // Image upload for payment proof (seller recharge request - S3)
  UPLOAD_RECHARGE_PROOF: "recharge-proof",
  // Public upload (for /rc/imcash - no auth)
  UPLOAD_RECHARGE_PROOF_PUBLIC: "recharge-proof-public",
  // Public recharge request
  RECHARGE_REQUEST_PUBLIC: "user/recharge-request/public",
  // Get CIN by registered email (for /rc/imcash auto-fill)
  RECHARGE_CIN_BY_EMAIL: "user/recharge-request/cin-by-email",

  // IM Points Management
  ADMIN_IM_POINTS_USERS: "admin/im-points/users",
  ADMIN_IM_POINTS_ASSIGN: "admin/im-points/assign",
  ADMIN_IM_POINTS_UPDATE: "admin/im-points",
  ADMIN_IM_POINTS_TRANSACTIONS: "admin/im-points/transactions",
  USER_IM_POINTS: "user/im-points",

  // Admin Affiliate Management
  ADMIN_GET_AFFILIATES: "admin/affiliates",
  ADMIN_GET_COMMISSION_PLANS: "admin/commission-plans",
  ADMIN_GET_PAYOUT_SETTINGS: "admin/payout-settings",
  ADMIN_UPDATE_PAYOUT_SETTINGS: "admin/payout-settings",
  ADMIN_GET_WITHDRAWAL_REQUESTS: "admin/withdrawal-requests",
  ADMIN_APPROVE_WITHDRAWAL: "admin/withdrawal-requests/approve",
  ADMIN_REJECT_WITHDRAWAL: "admin/withdrawal-requests/reject",
  ADMIN_GET_FRAUD_ALERTS: "admin/fraud-alerts",
  ADMIN_BLOCK_FRAUD_USER: "admin/fraud-alerts/block",
  ADMIN_GET_AFFILIATE_DASHBOARD: "admin/affiliate-dashboard",
  ADMIN_GET_AFFILIATE_PROGRAM_SETTINGS: "admin/affiliate-program-settings",
  ADMIN_UPDATE_AFFILIATE_PROGRAM_SETTINGS: "admin/affiliate-program-settings",

  // China Update
  GET_CHINA_SHEET_SYNC_JOBS: "admin/china-update/sheet-sync-jobs",
  CHINA_SHEET_SYNC_JOBS_CANCEL: "admin/china-update/sheet-sync-jobs/cancel",
  CHINA_ORDER_DETAILS_SYNC_LIVE_SHEET: "admin/china-update/order-details/sync-live-sheet",
  CHINA_UPDATE_IMPORT: "admin/china-update/import",
  GET_CHINA_ORDER_DETAILS: "admin/china-update/order-details",
  GET_CHINA_IN_COMMENTS: "admin/china-update/in-comments",
  GET_POSTAGE_TO_INDIA: "admin/china-update/postage-to-india",
};
